import { AccordionSummary, Typography } from "@mui/material";

import styled from "styled-components";

export const AccordionTitle = styled(Typography)`
  color: #ffffff;
  font-family: "Raleway", sans-serif;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.3px;
`;

export const AccordionDescription = styled(Typography)`
  color: rgba(251, 244, 236, 0.7);
  font-family: "Raleway", sans-serif;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.6;

  a {
    color: #9cd3fd;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #fbf4ec;
    }
  }

  strong {
    color: #fbf4ec;
    font-weight: 500;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  /* Centre the row so the title is vertically centred. Only the chevron is
     top-aligned (via align-self below) so it still tracks the FIRST line of a
     multi-line question rather than the centre of the whole title. */
  align-items: center;

  /* Size the summary to its content in BOTH states (collapsed default is 48px,
     expanded was forced taller) so the title doesn't jump up when it opens and
     there's no empty band below the title/chevron. */
  min-height: unset;
  &.Mui-expanded {
    min-height: unset;
  }
  .MuiAccordionSummary-content {
    margin: 12px 0;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
  }
  /* Chevron: box height == the title's first-line height (font-size ×
     line-height) with the icon centred inside it, and margin-top == the
     content's top margin, so the chevron's centre lines up with the centre of
     the question's first line at any number of lines. A wider left margin gives
     the question more breathing room before the chevron. */
  .MuiAccordionSummary-expandIconWrapper {
    align-self: flex-start;
    display: flex;
    align-items: center;
    height: 1.3125rem; /* 0.9375rem title × 1.4 line-height */
    /* == the content's top margin, so the chevron's centre lands on the first
       line's centre: centred on single-line titles, first-line on multi-line. */
    margin-top: 12px;
    margin-left: 16px;
  }
  &:hover .MuiAccordionSummary-expandIconWrapper {
    color: #9cd3fd;
    transition: color 0.2s ease;
  }
`;
